import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Modal from 'material-ui/Modal';

import Icon from '../../../../Icon';
import Button from '../../../../Button';

import useOverflow from '../../../../../hooks/useIsOverflow';

import { selectAccountVaultsLocationsByAccountVaultId } from '../../../../../redux/payment-methods/selectors';

import styles from './styles.module.styl';

const PaymentMethodLocationsPopup = ({ cardId, onClose, opened }) => {
  const { formatMessage } = useIntl();

  const locations = useSelector(
    selectAccountVaultsLocationsByAccountVaultId(cardId),
  );

  const {
    ref,
    overflow: { y },
  } = useOverflow();

  const buttonTitle = formatMessage({ id: 'common.gotIt' });

  const infoText = formatMessage({ id: 'profile.payment.popup.locationsInfo' });

  return (
    <Modal open={opened} onClose={onClose}>
      <div className={styles.content}>
        <div className={cn(styles.info, { [styles.infoWithBoxShadow]: y })}>
          <Icon name="information" size={48} />
          <div className={styles.infoText}>{infoText}</div>
        </div>
        <div ref={ref} className={styles.locations}>
          {locations.map(({ id, name, fullAddress }) => (
            <div key={id} className={styles.location}>
              {name} - {fullAddress}
            </div>
          ))}
        </div>
        <div className={cn(styles.footer, { [styles.footerWithTopBorder]: y })}>
          <Button color="primary" onClick={onClose} className={styles.button}>
            {buttonTitle}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PaymentMethodLocationsPopup.propTypes = {
  cardId: PropTypes.number,
  onClose: PropTypes.func,
  opened: PropTypes.bool,
};

export default PaymentMethodLocationsPopup;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/Payments/PaymentMethodLocationsPopup/index.jsx